export default __webpack_public_path__ + "media/zurb/img/bryan/pd-1-a266a7b0ad6ece7425331a16b9f3b313.png";